type Props = {
  height?: number;
  width?: number;
  className?: string;
};

const ViewAll = (props: Props) => {
  const { height = 13, width = 13, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 13 13"
      className={className}
    >
      <path className="fill-brand" d="M7.22 6.825 4.747 4.35l.537-.538 3.013 3.013-3.013 3.012-.537-.537L7.22 6.825Z" />
    </svg>
  );
};
export default ViewAll;
